import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { NotAuthGuard } from '@core/guard/NotAuthGuard';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('@pages/pages.module').then(m => m.PagesModule),
  },
  {
    path: 'login',
    loadChildren: () => import('@pages/unauthorized/login/login.module').then(m => m.LoginModule),
    canActivate: [NotAuthGuard],
  },
  {
    path: '403',
    loadChildren: () => import('@pages/forbidden/forbidden.module').then(m => m.ForbiddenModule),
  },
  {
    path: '404',
    loadChildren: () => import('@pages/not-found/not-found.module').then(m => m.NotFoundModule),
  },
  {
    path: '**',
    loadChildren: () => import('@pages/not-found/not-found.module').then(m => m.NotFoundModule),
  },
];

const config: ExtraOptions = {
  useHash: false,
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
